/* global angular, console */

'use strict';

angular
        .module( 'angular-google-analytics', [] )
        .provider( 'Analytics', function() {
                var created = false,
                        trackRoutes = true,
                        accountId,
                        trackPrefix = '',
                        domainName;

                this._logs = [];

                // config methods
                this.setAccount = function( id ) {
                        // console.log( "Setting GA account id: " + id )
                        accountId = id;
                        return true;
                };

                this.trackPages = function( doTrack ) {
                        // console.log( "Setting pages tracker to: " +doTrack )
                        trackRoutes = doTrack;
                        return true;
                };

                this.trackPrefix = function( prefix ) {
                        trackPrefix = prefix;
                        return true;
                };

                this.setDomainName = function( domain ) {
                        domainName = domain;
                        return true;
                };

                // public service
                this.$get = [
                        '$document',
                        '$rootScope',
                        '$location',
                        '$window',
                        function( $document, $rootScope, $location, $window ) {

                        /*----------------------------------
                                Private Methods
                        ----------------------------------*/
                        function _createScriptTag() {

                                // inject the google analytics tag
                                if (!accountId) return;

                                //$window._gaq = [];
                                //$window._gaq.push( [ '_setAccount', accountId ] );

                                //if (trackRoutes) $window._gaq.push(['_trackPageview']);
                                //if(domainName) $window._gaq.push(['_setDomainName', domainName]);

                                //(function() {
                                //      var document = $document[0];
                                //      var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true;
                                //      ga.src = ('https:' === document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js';
                                //      var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s);
                                //})();
                                created = true;
                        }

                        this._log = function() {
                                // for testing
                                this._logs.push(arguments);
                        };

                        this._trackPage = function( url ) {
                                //if (trackRoutes && $window._gaq) {
                                //      $window._gaq.push(['_trackPageview', trackPrefix + url]);
                                //      this._log('_trackPageview', arguments);
                                //}
								if (trackRoutes) {
										gtag('event', 'page_view', {
												page_location: trackPrefix + url,
												client_id: "",
												language: "en_us",
												page_encoding: "utf-8",
												page_title: $document.title,
												user_agent: ""
										});
										console.log("page_view: " + trackPrefix + url);
										this._log('_trackPageview', arguments);
								}
                        };

                        this._trackEvent = function( category, action, label, value ) {
                                //if ($window._gaq) {
                                //      $window._gaq.push(['_trackEvent', category, action, label, value]);
                                //      this._log('trackEvent', arguments);
                                //}
								gtag('event', category, {
										action: action,
										label: label,
										value: value
								});
								this._log('trackEvent', arguments);
                        };

                        /**
                        * Add transaction
                        * https://developers.google.com/analytics/devguides/collection/gajs/methods/gaJSApiEcommerce#_gat.GA_Tracker_._addTrans
                        * @param transactionId
                        * @param affiliation
                        * @param total
                        * @param tax
                        * @param shipping
                        * @param city
                        * @param state
                        * @param country
                        * @private
                        */
                        this._addTrans = function (transactionId, affiliation, total, tax, shipping, city, state, country) {
                                //if ($window._gaq) {
                                //      $window._gaq.push( [ '_addTrans', transactionId, "ATMGurus", total, tax, shipping, city, state, country ] );
                                //      this._log( '_addTrans', arguments );
                                //}
                        };

                        /**
                        * Add item to transaction
                        * https://developers.google.com/analytics/devguides/collection/gajs/methods/gaJSApiEcommerce#_gat.GA_Tracker_._addItem
                        * @param transactionId
                        * @param sku
                        * @param name
                        * @param category
                        * @param price
                        * @param quantity
                        * @private
                        */
                        this._addItem = function (transactionId, sku, name, category, price, quantity) {
                                //if ($window._gaq) {
                                //      $window._gaq.push(['_addItem', transactionId, sku, name, category, price, quantity]);
                                //      this._log('_addItem', arguments);
                                //}
								gtag('event', 'add_to_cart', {
									currency: "USD",
									value: price,
									items: [{
										item_id: sku,
										item_name: name,
										item_category: category,
										price: price,
										quantity: quantity
									}]
								});
                        };

                        /**
                        * Track transaction
                        * https://developers.google.com/analytics/devguides/collection/gajs/methods/gaJSApiEcommerce#_gat.GA_Tracker_._trackTrans
                        * @private
                        */
                        this._trackTrans = function (transactionId, affiliation, total, tax, shipping, city, state, country, lineItems) {
                                //if ($window._gaq) {
                                //      $window._gaq.push(['_trackTrans']);
                                //}
                                //this._log('_trackTrans', arguments);

								var myitems = '[';

								lineItems.forEach(function(item) {
										myitems +=
												'{item_id: \"' + item.item_primary_key + '\",' +
												'item_name: \"' + item.item_group + '\",' +
												'item_description: \"' + item.description + '\",' +
												'affiliation: \"' + affiliation + '\",' +
												'price: ' + item.selling_price + ',' +
												'quantity: ' + item.quantity + '},';
								});

								// trim off the last comma
								myitems = myitems.substring(0, myitems.length - 1);
								myitems += ']';

								gtag('event', 'purchase',  {
										currency: "USD",
										transaction_id: transactionId,
										value: total,
										shipping: shipping,
										tax: tax,
										city: city,
										state: state,
										country: country,
										items: myitems
								});
								this._log('_trackTrans', arguments);
                        };

						this._login = function (email) {
								gtag('event', 'login', {
										method: "ATMGurus.com",
										user: email
								});
								console.log("login successful");
								this._log('login', arguments);
						};

                        // creates the ganalytics tracker
                         _createScriptTag();

                        var _this = this;

                        // activates page tracking
                        if (trackRoutes) { 
								$rootScope.$on('$stateChangeSuccess', function() {
                                    //$transitions.onSuccess({}, function() {
                                	_this._trackPage( $location.url() );
                                    //console.log("page_view: " + $location.url());
                                });
                        }

                        return {
                                _logs: _this._logs,
                                trackPage: function( url ) {
                                        // add a page event
                                        _this._trackPage(url);
                                },
                                trackEvent: function( category, action, label, value ) {
                                        // add an action event
                                        _this._trackEvent(category, action, label, value);
                                },
                                addTrans: function ( transactionId, affiliation, total, tax, shipping, city, state, country ) {
                                        // console.log(transactionId, affiliation, total, tax, shipping, city, state, country)
                                        _this._addTrans(transactionId, affiliation, total, tax, shipping, city, state, country);
                                },
                                addItem: function ( transactionId, sku, na_this, category, price, quantity ) {
                                        // console.log( transactionId, sku, na_this, category, price, quantity )
                                        _this._addItem(transactionId, sku, na_this, category, price, quantity);
                                },
                                trackTrans: function ( transactionId, affiliation, total, tax, shipping, city, state, country, lineItems ) {
                                        _this._trackTrans(transactionId, affiliation, total, tax, shipping, city, state, country, lineItems);
                                },
								login: function ( email ) {
									_this._login(email);
								}
                        };
                }];
        });



// WEBPACK FOOTER //
// ./src/app/modules/google-analytics/angular-google-analytics.js